import { api, catchErrorHandler } from "utils/api";

export const getUserInfo = async () => {
  try {
    const { data } = await api.get(`/mobile/manager`);
    return data;
  } catch (error) {
    return false;
  }
};

export const patchProfileImg = async (formData) => {
  try {
    const { status } = await api.patch(`/coaches/profile`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return status === 200;
  } catch (error) {
    return catchErrorHandler(error, "patchProfileImg");
  }
};

export const patchDefaultProfileImg = async () => {
  try {
    const { status } = await api.patch(`/coaches/default/image`);
    return status === 200;
  } catch (error) {
    return catchErrorHandler(error, "patchDefaultProfileImg");
  }
};

export const patchUserName = async ({ seqManagerMobile, name }) => {
  try {
    const { status } = await api.patch(`/mobile/name`, {
      name,
    });
    return status === 200;
  } catch (error) {
    return catchErrorHandler(error, "patchUserName");
  }
};

export const confirmOldPass = async ({ phoneNumber, passCode }) => {
  try {
    const { status } = await api.post(`/mobile/verify-pass-code`, {
      phoneNumber,
      passCode,
    });
    return status === 200;
  } catch (error) {
    return false;
  }
};

export const patchPasscode = async ({ oldPassCode, passCode }) => {
  try {
    const { status } = await api.patch(`/mobile/pass-code-v2`, {
      oldPassCode,
      passCode,
    });
    return status === 200;
  } catch (error) {
    return catchErrorHandler(error, "patchPasscode");
  }
};

export const getNotiSetList = async () => {
  try {
    const { data } = await api.get(`/alarm/setting`);
    return data;
  } catch (error) {
    return catchErrorHandler(error, "getNotiSetList");
  }
};

export const patchNotiSetList = async (value, checked) => {
  try {
    const { status } = await api.patch(`/alarm/setting`, {
      seqManagerAlarmSetting: value,
      lever: checked ? "ON" : "OFF",
    });
    return status === 200;
  } catch (error) {
    return catchErrorHandler(error, "patchNotiSetList");
  }
};

export const patchMarketingAgree = async (marketingYN) => {
  try {
    const { status } = await api.patch(`/mobile/marketing-agreement`, {
      marketingYN,
    });
    return status === 200;
  } catch (error) {
    return catchErrorHandler(error, "patchMarketingAgree");
  }
};
